import React, { useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import './pcsb-landing.css';
import api from '../../../../apis';
import { useLoading } from '../../../../context/LoadingContext';
import PcsbBanner from './PcsbBanner';

const PRODUCT_CARDS = [
    {
        title: 'Online Trading Account',
        desc: 'Trade anytime, anywhere with our mobile-friendly trading platform.',
        icon: 'bi-phone'
    },
    {
        title: 'Trading Account',
        desc: 'Access IPO opportunities and a full suite of trading services.',
        icon: 'bi-graph-up-arrow'
    },
    {
        title: 'Collateralised Accounts',
        desc: 'Leverage your holdings to increase your trading power.',
        icon: 'bi-bank'
    },
    {
        title: 'Foreign Share Account',
        desc: 'Access international markets and diversify your portfolio.',
        icon: 'bi-globe'
    },
    {
        title: 'Cash Upfront Account',
        desc: 'Trade with minimal fees on a cash upfront basis.',
        icon: 'bi-wallet2'
    },
    {
        title: 'Flexi 7 Account',
        desc: 'Enjoy extended settlement periods for greater flexibility.',
        icon: 'bi-calendar-week'
    }
];



const PcsbLanding = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isHome = location.pathname === '/' || location.pathname === '/home';
    const [marketTab, setMarketTab] = useState(null);
    const [showLogin, setShowLogin] = useState(false);

    const { loading, setLoading } = useLoading();

    const [uid, setUserId] = useState('');
    const [pwd, setUserPwd] = useState('');
    const [securitycode, setSecuritycode] = useState('');
    const [loginErrMsg, setLoginErrMsg] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoginErrMsg('');
        setLoading(true);

        const result = await api.userLoginMFA({
            username: uid,
            password: pwd,
            secret_code: securitycode,
            geolocation: null
        });

        if (result != false && result.status == 0) {
            window.location.href = '/';
        } else {
            setLoading(false);
        }
    };

    return (
        <div className="pcsbLanding">
            {/* Header */}
            <div className="pcsbTopBar"></div>
            <header className="pcsbHeader">
                <div className="pcsbContainer pcsbHeaderInner">
                    <a href="/pcsb-landing" className="pcsbLogo">
                        <img src="/img/PhillipX.png" alt="PhillipTrade" className="pcsbLogoImg" />
                    </a>

                    <div className="pcsbHeaderActions">
                        <a href="/contact" className="pcsbContactLink pr-4">
                            <i className="bi bi-telephone-fill"></i> Contact Us
                        </a>

                        <div className="pcsbLoginWrap">
                            <button
                                type="button"
                                className="pcsbPillBtn"
                                onClick={() => setShowLogin((v) => !v)}
                            >
                                <i className="bi bi-person-circle"></i> LOGIN
                            </button>

                            {showLogin && (
                                <div className="pcsbLoginDropdown">
                                    <form onSubmit={handleLogin}>
                                        <label>User ID</label>
                                        <input
                                            type="text"
                                            name="username"
                                            required
                                            value={uid}
                                            onChange={(e) => setUserId(e.target.value)}
                                        />

                                        <label>Password</label>
                                        <div style={{ position: 'relative' }}>
                                            <input
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                required
                                                value={pwd}
                                                style={{ width: '100%', boxSizing: 'border-box' }}
                                                onChange={(e) => setUserPwd(e.target.value)}
                                            />
                                            <span
                                                onClick={togglePassword}
                                                style={{
                                                    position: 'absolute',
                                                    right: '10px',
                                                    top: '10px',
                                                    cursor: 'pointer',
                                                    userSelect: 'none'
                                                }}
                                            >
                                                <i
                                                    className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'}`}
                                                ></i>
                                            </span>
                                        </div>

                                        <label>Security Code</label>
                                        <input
                                            type="text"
                                            name="securitycode"
                                            value={securitycode}
                                            onChange={(e) => setSecuritycode(e.target.value)}
                                        />

                                        {loginErrMsg && (
                                            <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>
                                                {loginErrMsg}
                                            </div>
                                        )}

                                        {/* <div>
                                            <a>How to generate a security code &gt;</a>
                                        </div> */}

                                        <a
                                            className="pcsbForgotLink"
                                            onClick={() => {
                                                navigate('/forget-password');
                                            }}
                                        >
                                            Forgot Password / Unblock Account
                                        </a>

                                        <a
                                            className="pcsbForgotLink"
                                            onClick={() => {
                                                navigate('/forget-userid');
                                            }}
                                        >
                                            Forgot User ID?
                                        </a>

                                        <a
                                            className="pcsbForgotLink pb-3"
                                            onClick={() => {
                                                navigate('/first-time-login');
                                            }}
                                        >
                                            First Time Login
                                        </a>

                                        <button type="submit" className="pcsbLoginSubmit" disabled={loading}>
                                            {loading ? 'LOGGING IN...' : 'LOGIN'} <i className="bi bi-arrow-right"></i>
                                        </button>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>

            {/* Hero banner carousel, or inner page content */}
            {isHome ? <PcsbBanner /> : <Outlet />}

            {/* Product cards */}
            {/* <section className="pcsbSection pcsbSectionAlt">
                <div className="pcsbContainer">
                    <h3 className="pcsbSectionTitle">Our Accounts</h3>
                    <div className="pcsbProductGrid">
                        {PRODUCT_CARDS.map((card) => (
                            <div className="pcsbProductCard" key={card.title}>
                                <i className={`bi ${card.icon}`}></i>
                                <h4>{card.title}</h4>
                                <p>{card.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* Upper footer */}
            <div className="pcsbUpperFooter">
                <div className="pcsbContainer pcsbUpperFooterInner">
                    <a
                        href="https://www.phillipcapital.com.my/contact-us/"
                        // target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="pcsbUpperFooterIcon">
                            <i className="bi bi-question-lg"></i>
                        </span>
                        GIVE US YOUR FEEDBACK
                    </a>
                    <a
                        onClick={() => {
                            navigate('/faq');
                        }}
                    >
                        <span className="pcsbUpperFooterIcon">
                            <i className="bi bi-info-lg"></i>
                        </span>
                        FAQ
                    </a>
                    <a
                        onClick={() => {
                            navigate('/guide');
                        }}
                    >
                        <span className="pcsbUpperFooterIcon">
                            <i className="bi bi-question-lg"></i>
                        </span>
                        GUIDE
                    </a>
                </div>
            </div>

            {/* Footer */}
            <footer className="pcsbFooter">
                <div className="pcsbContainer pcsbFooterInner">
                    <ul className="pcsbFooterLinks">
                        <li>
                            <a
                                href="https://www.phillipcapital.com.my/privacy-policy/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </a>
                        </li>
                        <li className="pcsbFooterDivider">|</li>
                        <li className="pcsbFooterCopyright">
                            Copyright &copy; 2022 Phillip Capital Sdn Bhd (199501033331 / 362533-U)
                        </li>
                    </ul>
                </div>
            </footer>
            <div className="pcsbFooterBar"></div>
        </div>
    );
};

export default PcsbLanding;